import { TranslateService } from '@ngx-translate/core';

// A role seeded after this portal release has no translation yet; the API's own display name is
// the fallback rather than the raw key.
export function roleLabel(
  translate: Pick<TranslateService, 'instant'>,
  roleCode: string,
  apiDisplayName: string,
): string {
  const key = `installations.roles.${roleCode}`;
  const translated = translate.instant(key);
  return translated === key ? apiDisplayName : translated;
}
